import React from 'react';
import styled from 'react-emotion';
import { colors, mq, rWidth } from '../../../css';

export default ({
    image,
    left = true,
    backgroundColor = colors.white,
    order = 0,
    component,
    overrideWidth = false,
}) => (
    <s.wrapper {...{ backgroundColor, order }}>
        <s.customWrapper {...{ left, overrideWidth }}>
            {component}
        </s.customWrapper>
    </s.wrapper>
);

const s = {};

s.wrapper = styled('div')`
    background: ${props => props.backgroundColor};
    display: flex;
    ${props =>
        mq({
            order: [props.order, props.order, props.order, 0],
        })};
    ${mq({
        width: ['100%', '100%', '100%', '50%'],
    })};
`;

s.customWrapper = styled('div')`
    position: relative;
    height: 100%;
    margin-left: ${props => (props.left ? 0 : 'auto')};
    ${mq({
        width: [
            '100%',
            '100%',
            '100%',
            props =>
                props.overrideWidth
                    ? '100%'
                    : `calc(100% - ${rWidth(160 / 2)})`,
            props =>
                props.overrideWidth
                    ? '100%'
                    : `calc(100% - ${rWidth(160 / 2)})`,
            props =>
                props.overrideWidth ? '100%' : `calc(100% - ${rWidth(160)})`,
        ],
    })};
`;



// WEBPACK FOOTER //
// ./src/components/common/customBlock/customBlock.component.js